/**
 * Afterburner battery charge indicator.
 */

import { BATTERY_MAX } from '@warmancer/shared';
import styles from './GameHUD.module.css';

interface BatteryBarProps {
  readonly battery: number;
}

export function BatteryBar({ battery }: BatteryBarProps) {
  const percent = Math.round((battery / BATTERY_MAX) * 100);
  const isLow = percent < 20;

  return (
    <div className={styles.batteryContainer}>
      <span className={styles.hudLabel}>BOOST</span>
      <div className={styles.batteryTrack}>
        <div
          className={`${styles.batteryFill} ${isLow ? styles.batteryLow : ''}`}
          style={{ width: `${percent}%` }}
        />
      </div>
      <span className={styles.hudValue}>{percent}%</span>
    </div>
  );
}
